import Head from "next/head";
import type { FC, ReactNode } from "react";

type NoIndexHeadProps = {
  readonly children?: ReactNode;
};

export const NoIndexHead: FC<NoIndexHeadProps> = ({ children }) => (
  <Head>
    <meta name="robots" content="noindex, nofollow" />
    {children}
  </Head>
);
